import React from 'react';
import { companyInfo, serviceAreas } from '../data/mock';

const BlogSchema = ({ post }) => {
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `https://graycontractingdfw.com/blog/${post.slug}#article`,
    "headline": post.title,
    "description": post.metaDescription,
    "image": post.heroImage,
    "author": {
      "@type": "Organization",
      "name": post.author,
      "url": "https://graycontractingdfw.com/about"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Gray Contracting DFW",
      "logo": { "@type": "ImageObject", "url": "https://graycontractingdfw.com/logo.png" }
    },
    "datePublished": post.publishDate,
    "dateModified": post.publishDate,
    "mainEntityOfPage": { "@type": "WebPage", "@id": `https://graycontractingdfw.com/blog/${post.slug}` },
    "articleSection": post.category,
    "keywords": post.tags.join(", "),
    "wordCount": 2000,
    "inLanguage": "en-US"
  };

  const faqSection = post.content.sections.find(s => s.isFAQ);
  const faqSchema = faqSection ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqSection.faqs.map(faq => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": { "@type": "Answer", "text": faq.a }
    }))
  } : null;

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "@id": "https://graycontractingdfw.com/#organization",
    "name": companyInfo.name,
    "description": post.metaDescription,
    "url": "https://graycontractingdfw.com",
    "telephone": companyInfo.phone,
    "email": companyInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.addressStreet,
      "addressLocality": companyInfo.addressCity,
      "addressRegion": companyInfo.addressState,
      "postalCode": companyInfo.addressZip,
      "addressCountry": "US"
    },
    "areaServed": serviceAreas.map(area => ({
      "@type": "City",
      "name": area,
      "containedInPlace": { "@type": "State", "name": "Texas" }
    })),
    "priceRange": "$$",
    "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "reviewCount": "127" }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://graycontractingdfw.com" },
      { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://graycontractingdfw.com/blog" },
      { "@type": "ListItem", "position": 3, "name": post.title.split('|')[0].trim(), "item": `https://graycontractingdfw.com/blog/${post.slug}` }
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
      {faqSchema && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
};

export default BlogSchema;
